import { makeStyles } from "@material-ui/styles"

export default makeStyles({
  loginBlock: {
    display: "flex",
    gap: "1rem",
    flexDirection: "column",
  },
})
